import { createContext } from 'react';
import { DeviceOutput } from '../util/output/device';

export const DeviceOutputContext = createContext<{output?: DeviceOutput}>({});